import { TimeInfo } from 'utils/constants/informationText';
import { getEventCategoryByServices } from 'containers/Pages/Events/Layouts';
import {
  RISK_CONSEQUENCE_OPTIONS,
  RISK_LIKELIHOOD_OPTIONS,
} from 'utils/constants/risks';
import { transformTimezone } from 'utils/DataTransform/utils';
import { LOCATION_MODE } from 'utils/constants/Map';
import {
  validateArrayRequirement,
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';
export const validationSchema = validationObject({
  name: validateString(30, true),
  defaultTimeZone: validateRequired(),
  currency: validateString(5, true),
  context: validateRequired(),
  consequence: validateRequired(),
  likelihood: validateRequired(),
  paths: validateArrayRequirement(3),
  locations: validateRequired(),
});
export const regionGeneralSection = ({ services, timezones }) => {
  return [
    {
      field: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      size: 'full',
      placeholder: 'Enter a region name',
    },
    {
      field: 'defaultTimeZone',
      label: 'Default time zone',
      type: 'select',
      required: true,
      size: 'full',
      options: transformTimezone(timezones),
      info: TimeInfo.timezone,
    },
    {
      field: 'currency',
      label: 'Currency',
      type: 'text',
      required: true,
      size: 'full',
      placeholder: 'Enter currency code',
    },
    {
      field: 'services',
      label: 'AvailableServices',
      type: 'checkbox-options',
      required: true,
      options: services,
      size: 'full',
    },
    {
      field: 'context',
      label: 'Hazard context',
      type: 'select',
      required: true,
      size: 'full',
      options: getEventCategoryByServices(services),
    },
    {
      field: 'consequence',
      type: 'select',
      required: true,
      size: 'half',
      options: RISK_CONSEQUENCE_OPTIONS,
    },
    {
      field: 'likelihood',
      type: 'select',
      required: true,
      size: 'half',
      options: RISK_LIKELIHOOD_OPTIONS,
    },
    {
      field: 'description',
      type: 'textArea',
      maxLength: 250,
      placeholder: 'Enter description',
    },
    {
      field: 'defaultRecommendation',
      type: 'textArea',
      maxLength: 250,
      placeholder: 'Enter a default recommendation',
    },
  ];
};

export const regionDetailSection = () => {
  return [
    {
      field: 'welcomeInformation',
      required: false,
      label: 'Welcome Information',
      type: 'text',
      maxLength: 250,
    },
    {
      field: 'locations',
      required: true,
      label: 'Region Boundary',
      type: 'polygon-creator',
      eventType: 'REGION',
      secondaryValue: 'paths',
      additionalPolygonMode: LOCATION_MODE.HIGH_DETAIL,
    },
  ];
};

export const regionInitialState = () => {
  return {
    name: undefined,
    hazard: undefined,
    consequence: undefined,
    likelihood: undefined,
    paths: undefined,
    locations: undefined,
  };
};
